// built-in imports
import React from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// internal imports
import ProjectCard from "../project-cart/project-cart.component";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1217 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1217, min: 830 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 830, min: 0 },
    items: 1,
  },
};

const CustomDot = ({ len, onClick, ...rest }) => {
  const {
    onMove,
    index,
    active,
    carouselState: { currentSlide, deviceType },
  } = rest;
  // onMove means if dragging or swiping in progress.
  // active is provided by this lib for checking if the item is active or not.

  return (
    <button
      className={`bg-transparent h-[10px] rounded-full mx-1 transition-all duration-200 ease-linear`}
      onClick={() => onClick()}
      style={{
        backgroundColor: active
          ? "var(--text-color)"
          : "var(--text-secondary-color)",
        width: active ? "20px" : "10px",
      }}
    >
      {React.Children.toArray(Array(len).fill(""))[index]}
    </button>
  );
};

const ProjectsSlider = ({ data }) => {
  return (
    data.length > 0 && (
      <Carousel
        arrows={true}
        swipeable={true}
        draggable={true}
        showDots
        customDot={<CustomDot len={data.length} />}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={6000}
        customTransition="all .5"
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {data?.map((project, index) => (
          <ProjectCard
            key={`key-${index}-${project.id}`}
            index={index}
            {...project}
          />
        ))}
      </Carousel>
    )
  );
};
export default ProjectsSlider;
